// extracted by mini-css-extract-plugin
export default {"container":"CodePreviewComponent_container__IaMjK","onlyContent":"CodePreviewComponent_onlyContent__xWmyu"};